import MagicWand from '@components/icons/MagicWand.svg';
import { useAPI } from '@providers/useAPI';
import { useMutation } from '@tanstack/react-query';
import { AdminService } from 'app/API';
import { usePageContext } from '../../../../../../providers/PageProvider';
import { ToolbarActionButton } from '@components/core-ui/form-elements/buttons/Button/variations/ToolbarActionButton';

export const ParseTranscriptButton = () => {
  const { job, manualReload } = usePageContext();
  const { call } = useAPI();

  const parseMutation = useMutation({
    mutationFn: ({ jobId, versionId }: { jobId: string; versionId: string }) =>
      call(() => AdminService.parseTranscript({ jobId, versionId })),
    onSuccess: () => manualReload(),
  });

  if (!job || !job.versions?.length || job?.transcriptId) {
    return null;
  }

  return (
    <ToolbarActionButton
      className="w-[155px]"
      type="button"
      title="Resubmit"
      onClick={() => {
        if (!job.versions) {
          return;
        }
        parseMutation.mutate({ jobId: job.id, versionId: String(job.versions[0].id) });
      }}
    >
      <MagicWand />
      Parse transcript for AI
    </ToolbarActionButton>
  );
};
